// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,json_types=true"
// @generated from file onboarding/v1/steps.proto (package onboarding.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any, AnyJson, StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { CreateInvitationV2WorkspaceRequest, CreateInvitationV2WorkspaceRequestJson, CreateInvitationV2WorkspaceResponse, CreateInvitationV2WorkspaceResponseJson, CreateWorkspaceRequest, CreateWorkspaceRequestJson, UpdateUserRequest, UpdateUserRequestJson, UpdateWorkspaceRequest, UpdateWorkspaceRequestJson, User, UserJson, Workspace, WorkspaceJson } from "../../identities/v1/identities_pb";
import { file_identities_v1_identities } from "../../identities/v1/identities_pb";
import type { CreateDomainRequest, CreateDomainRequestJson, Domain, DomainJson, UpdateDomainRequest, UpdateDomainRequestJson } from "../../links/v1/links_pb";
import { file_links_v1_links } from "../../links/v1/links_pb";
import type { CreateTagRequest, CreateTagRequestJson, GenerateTagCodeResponse, GenerateTagCodeResponseJson, Tag, TagJson, UpdateTagRequest, UpdateTagRequestJson } from "../../pixel_tracker/v1/pixel_tracker_pb";
import { file_pixel_tracker_v1_pixel_tracker } from "../../pixel_tracker/v1/pixel_tracker_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file onboarding/v1/steps.proto.
 */
export const file_onboarding_v1_steps: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_google_protobuf_any, file_google_protobuf_struct, file_identities_v1_identities, file_links_v1_links, file_pixel_tracker_v1_pixel_tracker],
	);

/**
 * @generated from message onboarding.v1.StepData
 */
export type StepData = Message<"onboarding.v1.StepData"> & {
	/**
	 * @generated from field: google.protobuf.Struct metadata = 1;
	 */
	metadata?: JsonObject;

	/**
	 * @generated from field: google.protobuf.Any payload = 2;
	 */
	payload?: Any;

	/**
	 * @generated from field: google.protobuf.Any result = 3;
	 */
	result?: Any;

	/**
	 * @generated from field: onboarding.v1.SkipStepPayload skip_payload = 4;
	 */
	skipPayload?: SkipStepPayload;
};

/**
 * @generated from message onboarding.v1.StepData
 */
export type StepDataJson = {
	/**
	 * @generated from field: google.protobuf.Struct metadata = 1;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: google.protobuf.Any payload = 2;
	 */
	payload?: AnyJson;

	/**
	 * @generated from field: google.protobuf.Any result = 3;
	 */
	result?: AnyJson;

	/**
	 * @generated from field: onboarding.v1.SkipStepPayload skip_payload = 4;
	 */
	skipPayload?: SkipStepPayloadJson;
};

/**
 * Describes the message onboarding.v1.StepData.
 * Use `create(StepDataSchema)` to create a new message.
 */
export const StepDataSchema: GenMessage<StepData, { jsonType: StepDataJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 0);

/**
 * @generated from message onboarding.v1.SkipStepPayload
 */
export type SkipStepPayload = Message<"onboarding.v1.SkipStepPayload"> & {
	/**
	 * @generated from field: string reason = 1;
	 */
	reason: string;

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients: string[];
};

/**
 * @generated from message onboarding.v1.SkipStepPayload
 */
export type SkipStepPayloadJson = {
	/**
	 * @generated from field: string reason = 1;
	 */
	reason?: string;

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients?: string[];
};

/**
 * Describes the message onboarding.v1.SkipStepPayload.
 * Use `create(SkipStepPayloadSchema)` to create a new message.
 */
export const SkipStepPayloadSchema: GenMessage<SkipStepPayload, { jsonType: SkipStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 1);

/**
 * @generated from message onboarding.v1.DisplayContentStepPayload
 */
export type DisplayContentStepPayload = Message<"onboarding.v1.DisplayContentStepPayload"> & {};

/**
 * @generated from message onboarding.v1.DisplayContentStepPayload
 */
export type DisplayContentStepPayloadJson = {};

/**
 * Describes the message onboarding.v1.DisplayContentStepPayload.
 * Use `create(DisplayContentStepPayloadSchema)` to create a new message.
 */
export const DisplayContentStepPayloadSchema: GenMessage<DisplayContentStepPayload, { jsonType: DisplayContentStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 2);

/**
 * @generated from message onboarding.v1.DisplayContentStepResult
 */
export type DisplayContentStepResult = Message<"onboarding.v1.DisplayContentStepResult"> & {};

/**
 * @generated from message onboarding.v1.DisplayContentStepResult
 */
export type DisplayContentStepResultJson = {};

/**
 * Describes the message onboarding.v1.DisplayContentStepResult.
 * Use `create(DisplayContentStepResultSchema)` to create a new message.
 */
export const DisplayContentStepResultSchema: GenMessage<DisplayContentStepResult, { jsonType: DisplayContentStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 3);

/**
 * @generated from message onboarding.v1.WorkspaceSetupStepPayload
 */
export type WorkspaceSetupStepPayload = Message<"onboarding.v1.WorkspaceSetupStepPayload"> & {
	/**
	 * @generated from oneof onboarding.v1.WorkspaceSetupStepPayload.request
	 */
	request:
		| {
				/**
				 * the request payload to create a workspace
				 *
				 * @generated from field: identities.v1.CreateWorkspaceRequest create_workspace_request = 1;
				 */
				value: CreateWorkspaceRequest;
				case: "createWorkspaceRequest";
		  }
		| {
				/**
				 * the request payload to update a workspace
				 *
				 * @generated from field: identities.v1.UpdateWorkspaceRequest update_workspace_request = 2;
				 */
				value: UpdateWorkspaceRequest;
				case: "updateWorkspaceRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message onboarding.v1.WorkspaceSetupStepPayload
 */
export type WorkspaceSetupStepPayloadJson = {
	/**
	 * the request payload to create a workspace
	 *
	 * @generated from field: identities.v1.CreateWorkspaceRequest create_workspace_request = 1;
	 */
	createWorkspaceRequest?: CreateWorkspaceRequestJson;

	/**
	 * the request payload to update a workspace
	 *
	 * @generated from field: identities.v1.UpdateWorkspaceRequest update_workspace_request = 2;
	 */
	updateWorkspaceRequest?: UpdateWorkspaceRequestJson;
};

/**
 * Describes the message onboarding.v1.WorkspaceSetupStepPayload.
 * Use `create(WorkspaceSetupStepPayloadSchema)` to create a new message.
 */
export const WorkspaceSetupStepPayloadSchema: GenMessage<WorkspaceSetupStepPayload, { jsonType: WorkspaceSetupStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 4);

/**
 * @generated from message onboarding.v1.WorkspaceSetupStepResult
 */
export type WorkspaceSetupStepResult = Message<"onboarding.v1.WorkspaceSetupStepResult"> & {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: Workspace;
};

/**
 * @generated from message onboarding.v1.WorkspaceSetupStepResult
 */
export type WorkspaceSetupStepResultJson = {
	/**
	 * @generated from field: identities.v1.Workspace workspace = 1;
	 */
	workspace?: WorkspaceJson;
};

/**
 * Describes the message onboarding.v1.WorkspaceSetupStepResult.
 * Use `create(WorkspaceSetupStepResultSchema)` to create a new message.
 */
export const WorkspaceSetupStepResultSchema: GenMessage<WorkspaceSetupStepResult, { jsonType: WorkspaceSetupStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 5);

/**
 * @generated from message onboarding.v1.WorkspaceInviteStepPayload
 */
export type WorkspaceInviteStepPayload = Message<"onboarding.v1.WorkspaceInviteStepPayload"> & {
	/**
	 * the request payload to create an invitation
	 *
	 * @generated from field: identities.v1.CreateInvitationV2WorkspaceRequest create_invitation_request = 1;
	 */
	createInvitationRequest?: CreateInvitationV2WorkspaceRequest;
};

/**
 * @generated from message onboarding.v1.WorkspaceInviteStepPayload
 */
export type WorkspaceInviteStepPayloadJson = {
	/**
	 * the request payload to create an invitation
	 *
	 * @generated from field: identities.v1.CreateInvitationV2WorkspaceRequest create_invitation_request = 1;
	 */
	createInvitationRequest?: CreateInvitationV2WorkspaceRequestJson;
};

/**
 * Describes the message onboarding.v1.WorkspaceInviteStepPayload.
 * Use `create(WorkspaceInviteStepPayloadSchema)` to create a new message.
 */
export const WorkspaceInviteStepPayloadSchema: GenMessage<WorkspaceInviteStepPayload, { jsonType: WorkspaceInviteStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 6);

/**
 * @generated from message onboarding.v1.WorkspaceInviteStepResult
 */
export type WorkspaceInviteStepResult = Message<"onboarding.v1.WorkspaceInviteStepResult"> & {
	/**
	 * the response from the create invitation call
	 *
	 * @generated from field: identities.v1.CreateInvitationV2WorkspaceResponse create_invitation_response = 1;
	 */
	createInvitationResponse?: CreateInvitationV2WorkspaceResponse;
};

/**
 * @generated from message onboarding.v1.WorkspaceInviteStepResult
 */
export type WorkspaceInviteStepResultJson = {
	/**
	 * the response from the create invitation call
	 *
	 * @generated from field: identities.v1.CreateInvitationV2WorkspaceResponse create_invitation_response = 1;
	 */
	createInvitationResponse?: CreateInvitationV2WorkspaceResponseJson;
};

/**
 * Describes the message onboarding.v1.WorkspaceInviteStepResult.
 * Use `create(WorkspaceInviteStepResultSchema)` to create a new message.
 */
export const WorkspaceInviteStepResultSchema: GenMessage<WorkspaceInviteStepResult, { jsonType: WorkspaceInviteStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 7);

/**
 * @generated from message onboarding.v1.ProfileSetupStepPayload
 */
export type ProfileSetupStepPayload = Message<"onboarding.v1.ProfileSetupStepPayload"> & {
	/**
	 * @generated from field: identities.v1.UpdateUserRequest update_user_request = 1;
	 */
	updateUserRequest?: UpdateUserRequest;
};

/**
 * @generated from message onboarding.v1.ProfileSetupStepPayload
 */
export type ProfileSetupStepPayloadJson = {
	/**
	 * @generated from field: identities.v1.UpdateUserRequest update_user_request = 1;
	 */
	updateUserRequest?: UpdateUserRequestJson;
};

/**
 * Describes the message onboarding.v1.ProfileSetupStepPayload.
 * Use `create(ProfileSetupStepPayloadSchema)` to create a new message.
 */
export const ProfileSetupStepPayloadSchema: GenMessage<ProfileSetupStepPayload, { jsonType: ProfileSetupStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 8);

/**
 * @generated from message onboarding.v1.ProfileSetupStepResult
 */
export type ProfileSetupStepResult = Message<"onboarding.v1.ProfileSetupStepResult"> & {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: User;
};

/**
 * @generated from message onboarding.v1.ProfileSetupStepResult
 */
export type ProfileSetupStepResultJson = {
	/**
	 * @generated from field: identities.v1.User user = 1;
	 */
	user?: UserJson;
};

/**
 * Describes the message onboarding.v1.ProfileSetupStepResult.
 * Use `create(ProfileSetupStepResultSchema)` to create a new message.
 */
export const ProfileSetupStepResultSchema: GenMessage<ProfileSetupStepResult, { jsonType: ProfileSetupStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 9);

/**
 * @generated from message onboarding.v1.CustomDomainSetupStepPayload
 */
export type CustomDomainSetupStepPayload = Message<"onboarding.v1.CustomDomainSetupStepPayload"> & {
	/**
	 * @generated from oneof onboarding.v1.CustomDomainSetupStepPayload.request
	 */
	request:
		| {
				/**
				 * the request payload to create a custom domain
				 *
				 * @generated from field: links.v1.CreateDomainRequest create_domain_request = 1;
				 */
				value: CreateDomainRequest;
				case: "createDomainRequest";
		  }
		| {
				/**
				 * the request payload to update a custom domain
				 *
				 * @generated from field: links.v1.UpdateDomainRequest update_domain_request = 2;
				 */
				value: UpdateDomainRequest;
				case: "updateDomainRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message onboarding.v1.CustomDomainSetupStepPayload
 */
export type CustomDomainSetupStepPayloadJson = {
	/**
	 * the request payload to create a custom domain
	 *
	 * @generated from field: links.v1.CreateDomainRequest create_domain_request = 1;
	 */
	createDomainRequest?: CreateDomainRequestJson;

	/**
	 * the request payload to update a custom domain
	 *
	 * @generated from field: links.v1.UpdateDomainRequest update_domain_request = 2;
	 */
	updateDomainRequest?: UpdateDomainRequestJson;
};

/**
 * Describes the message onboarding.v1.CustomDomainSetupStepPayload.
 * Use `create(CustomDomainSetupStepPayloadSchema)` to create a new message.
 */
export const CustomDomainSetupStepPayloadSchema: GenMessage<CustomDomainSetupStepPayload, { jsonType: CustomDomainSetupStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 10);

/**
 * @generated from message onboarding.v1.CustomDomainSetupStepResult
 */
export type CustomDomainSetupStepResult = Message<"onboarding.v1.CustomDomainSetupStepResult"> & {
	/**
	 * the resulting domain
	 *
	 * @generated from field: links.v1.Domain domain = 1;
	 */
	domain?: Domain;
};

/**
 * @generated from message onboarding.v1.CustomDomainSetupStepResult
 */
export type CustomDomainSetupStepResultJson = {
	/**
	 * the resulting domain
	 *
	 * @generated from field: links.v1.Domain domain = 1;
	 */
	domain?: DomainJson;
};

/**
 * Describes the message onboarding.v1.CustomDomainSetupStepResult.
 * Use `create(CustomDomainSetupStepResultSchema)` to create a new message.
 */
export const CustomDomainSetupStepResultSchema: GenMessage<CustomDomainSetupStepResult, { jsonType: CustomDomainSetupStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 11);

/**
 * @generated from message onboarding.v1.PixelSetupStepPayload
 */
export type PixelSetupStepPayload = Message<"onboarding.v1.PixelSetupStepPayload"> & {
	/**
	 * @generated from oneof onboarding.v1.PixelSetupStepPayload.request
	 */
	request:
		| {
				/**
				 * the request payload to create a pixel
				 *
				 * @generated from field: pixel_tracker.v1.CreateTagRequest create_tag_request = 1;
				 */
				value: CreateTagRequest;
				case: "createTagRequest";
		  }
		| {
				/**
				 * the request payload to update a pixel
				 *
				 * @generated from field: pixel_tracker.v1.UpdateTagRequest update_tag_request = 2;
				 */
				value: UpdateTagRequest;
				case: "updateTagRequest";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message onboarding.v1.PixelSetupStepPayload
 */
export type PixelSetupStepPayloadJson = {
	/**
	 * the request payload to create a pixel
	 *
	 * @generated from field: pixel_tracker.v1.CreateTagRequest create_tag_request = 1;
	 */
	createTagRequest?: CreateTagRequestJson;

	/**
	 * the request payload to update a pixel
	 *
	 * @generated from field: pixel_tracker.v1.UpdateTagRequest update_tag_request = 2;
	 */
	updateTagRequest?: UpdateTagRequestJson;
};

/**
 * Describes the message onboarding.v1.PixelSetupStepPayload.
 * Use `create(PixelSetupStepPayloadSchema)` to create a new message.
 */
export const PixelSetupStepPayloadSchema: GenMessage<PixelSetupStepPayload, { jsonType: PixelSetupStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 12);

/**
 * @generated from message onboarding.v1.PixelSetupStepResult
 */
export type PixelSetupStepResult = Message<"onboarding.v1.PixelSetupStepResult"> & {
	/**
	 * the resulting tag
	 *
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: Tag;

	/**
	 * @generated from field: pixel_tracker.v1.GenerateTagCodeResponse generate_tag_code_response = 2;
	 */
	generateTagCodeResponse?: GenerateTagCodeResponse;
};

/**
 * @generated from message onboarding.v1.PixelSetupStepResult
 */
export type PixelSetupStepResultJson = {
	/**
	 * the resulting tag
	 *
	 * @generated from field: pixel_tracker.v1.Tag tag = 1;
	 */
	tag?: TagJson;

	/**
	 * @generated from field: pixel_tracker.v1.GenerateTagCodeResponse generate_tag_code_response = 2;
	 */
	generateTagCodeResponse?: GenerateTagCodeResponseJson;
};

/**
 * Describes the message onboarding.v1.PixelSetupStepResult.
 * Use `create(PixelSetupStepResultSchema)` to create a new message.
 */
export const PixelSetupStepResultSchema: GenMessage<PixelSetupStepResult, { jsonType: PixelSetupStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 13);

/**
 * @generated from message onboarding.v1.IntegrationsOptInStepPayload
 */
export type IntegrationsOptInStepPayload = Message<"onboarding.v1.IntegrationsOptInStepPayload"> & {
	/**
	 * the request payload to opt-in to integrations
	 *
	 * @generated from field: repeated string integration_names = 1;
	 */
	integrationNames: string[];

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients: string[];
};

/**
 * @generated from message onboarding.v1.IntegrationsOptInStepPayload
 */
export type IntegrationsOptInStepPayloadJson = {
	/**
	 * the request payload to opt-in to integrations
	 *
	 * @generated from field: repeated string integration_names = 1;
	 */
	integrationNames?: string[];

	/**
	 * @generated from field: repeated string email_recipients = 2;
	 */
	emailRecipients?: string[];
};

/**
 * Describes the message onboarding.v1.IntegrationsOptInStepPayload.
 * Use `create(IntegrationsOptInStepPayloadSchema)` to create a new message.
 */
export const IntegrationsOptInStepPayloadSchema: GenMessage<IntegrationsOptInStepPayload, { jsonType: IntegrationsOptInStepPayloadJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 14);

/**
 * @generated from message onboarding.v1.IntegrationsOptInStepResult
 */
export type IntegrationsOptInStepResult = Message<"onboarding.v1.IntegrationsOptInStepResult"> & {};

/**
 * @generated from message onboarding.v1.IntegrationsOptInStepResult
 */
export type IntegrationsOptInStepResultJson = {};

/**
 * Describes the message onboarding.v1.IntegrationsOptInStepResult.
 * Use `create(IntegrationsOptInStepResultSchema)` to create a new message.
 */
export const IntegrationsOptInStepResultSchema: GenMessage<IntegrationsOptInStepResult, { jsonType: IntegrationsOptInStepResultJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_steps, 15);

/**
 * @generated from enum onboarding.v1.WorkflowType
 */
export enum WorkflowType {
	/**
	 * @generated from enum value: WORKFLOW_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: WORKFLOW_TYPE_BASE = 1;
	 */
	BASE = 1,

	/**
	 * @generated from enum value: WORKFLOW_TYPE_FIRST_ORG_ADMIN = 2;
	 */
	FIRST_ORG_ADMIN = 2,
}

/**
 * @generated from enum onboarding.v1.WorkflowType
 */
export type WorkflowTypeJson = "WORKFLOW_TYPE_UNSPECIFIED" | "WORKFLOW_TYPE_BASE" | "WORKFLOW_TYPE_FIRST_ORG_ADMIN";

/**
 * Describes the enum onboarding.v1.WorkflowType.
 */
export const WorkflowTypeSchema: GenEnum<WorkflowType, WorkflowTypeJson> = /*@__PURE__*/ enumDesc(file_onboarding_v1_steps, 0);

/**
 * StepType represents the type of a step in a workflow.
 *
 * @generated from enum onboarding.v1.StepType
 */
export enum StepType {
	/**
	 * Undefined step type.
	 *
	 * @generated from enum value: STEP_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * Display content step type.
	 *
	 * @generated from enum value: STEP_TYPE_DISPLAY_CONTENT = 1;
	 */
	DISPLAY_CONTENT = 1,

	/**
	 * Profile setup step type.
	 *
	 * @generated from enum value: STEP_TYPE_PROFILE_SETUP = 2;
	 */
	PROFILE_SETUP = 2,

	/**
	 * Organization setup step type.
	 *
	 * @generated from enum value: STEP_TYPE_ORG_SETUP = 3;
	 */
	ORG_SETUP = 3,

	/**
	 * Workspace setup step type.
	 *
	 * @generated from enum value: STEP_TYPE_WORKSPACE_SETUP = 4;
	 */
	WORKSPACE_SETUP = 4,

	/**
	 * Workspace invite step type.
	 *
	 * @generated from enum value: STEP_TYPE_WORKSPACE_INVITE = 5;
	 */
	WORKSPACE_INVITE = 5,

	/**
	 * Custom domain setup step type.
	 *
	 * @generated from enum value: STEP_TYPE_CUSTOM_DOMAIN_SETUP = 6;
	 */
	CUSTOM_DOMAIN_SETUP = 6,

	/**
	 * Pixel setup step type.
	 *
	 * @generated from enum value: STEP_TYPE_PIXEL_SETUP = 7;
	 */
	PIXEL_SETUP = 7,

	/**
	 * Integrations opt-in step type.
	 *
	 * @generated from enum value: STEP_TYPE_INTEGRATIONS_OPT_IN = 8;
	 */
	INTEGRATIONS_OPT_IN = 8,
}

/**
 * StepType represents the type of a step in a workflow.
 *
 * @generated from enum onboarding.v1.StepType
 */
export type StepTypeJson = "STEP_TYPE_UNSPECIFIED" | "STEP_TYPE_DISPLAY_CONTENT" | "STEP_TYPE_PROFILE_SETUP" | "STEP_TYPE_ORG_SETUP" | "STEP_TYPE_WORKSPACE_SETUP" | "STEP_TYPE_WORKSPACE_INVITE" | "STEP_TYPE_CUSTOM_DOMAIN_SETUP" | "STEP_TYPE_PIXEL_SETUP" | "STEP_TYPE_INTEGRATIONS_OPT_IN";

/**
 * Describes the enum onboarding.v1.StepType.
 */
export const StepTypeSchema: GenEnum<StepType, StepTypeJson> = /*@__PURE__*/ enumDesc(file_onboarding_v1_steps, 1);
